import { addToChainAfter, addToChainBefore } from "@insite/client-framework/HandlerCreator";
import {
    chain,
    DispatchCompletePlaceOrder,
    PopulateApiParameter,
} from "@insite/client-framework/Store/Pages/CheckoutReviewAndSubmit/Handlers/PlaceOrder";
import { CustomState } from "@solveindustrial/Store/Reducers";
import { clearSelectedCarrier } from "@solveindustrial/Utilities/sessionStorageUtils";

addToChainBefore(chain, PopulateApiParameter, props => {
    if (!props.cartToUpdate) {
        return;
    }

    const state = props.getState() as CustomState;

    const { shippingAcountNumber } = state.shippingAccountNumberState;

    if (!shippingAcountNumber) {
        return;
    }

    props.cartToUpdate.properties = {
        ...props.cartToUpdate.properties,
        shippingAccountNumber: shippingAcountNumber,
    };
});

addToChainAfter(chain, DispatchCompletePlaceOrder, props => {
    clearSelectedCarrier();
});
